import type { EventExpenseCategory, DiscountType } from '../api/types';

export const EXPENSE_CATEGORIES: { value: EventExpenseCategory; label: string }[] = [
  { value: 'RIMBORSO_SPESE',    label: 'Rimborso spese' },
  { value: 'STAMPE_ALBUM',      label: 'Stampe / Album' },
  { value: 'COMPENSO_TITOLARE', label: 'Compenso titolare' },
  { value: 'ALTRO',             label: 'Altro' },
];

export const EXPENSE_CATEGORY_COLORS: Record<EventExpenseCategory, string> = {
  RIMBORSO_SPESE:    'var(--color-warning)',
  STAMPE_ALBUM:      'var(--color-gold)',
  COMPENSO_TITOLARE: 'var(--color-primary)',
  ALTRO:             'var(--color-text-muted)',
};

export const TAX_MODE_OPTIONS = [
  { value: '',            label: 'Nessuno — non calcolare' },
  { value: 'FORFETTARIO', label: 'Forfettario' },
  { value: 'ORDINARIO',   label: 'Ordinario / IRPEF' },
];

export function effectivePrice(es: { unitPrice: number; discount?: number | null; discountType?: DiscountType | null }): number {
  const price = Number(es.unitPrice);
  if (es.discountType === 'FIXED' && es.discount != null)
    return Math.max(0, price - Number(es.discount));
  if (es.discountType === 'PERCENTAGE' && es.discount != null)
    return price * (1 - Number(es.discount) / 100);
  return price;
}

export const EMPTY_EXPENSE_FORM = {
  category:        'RIMBORSO_SPESE' as EventExpenseCategory,
  description:     '',
  amountEstimated: '',
  amountActual:    '',
  isPaid:          false,
  isOwnerFee:      false,
  ownerPresent:    true,
  notes:           '',
};

export const pct = (part: number, total: number) =>
  total > 0 ? Math.min(100, Math.max(0, (part / total) * 100)) : 0;

export const marginPct = (price: number, cost: number) =>
  price > 0 ? Math.round(((price - cost) / price) * 100) : 0;

export const marginColor = (p: number) =>
  p >= 50 ? 'var(--color-success)' : p >= 25 ? 'var(--color-warning)' : 'var(--color-error)';
